<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div @keyup.enter.stop="getPage({pageNum: 1})">
      <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
        <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
      </el-select>
      <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
      </el-select>
      <el-select v-model="queryParam.agentId" placeholder="考级点" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
      </el-select>
      <el-select v-model="queryParam.auditStatus" placeholder="审核状态" filterable clearable style="width: 200px;margin-right:10px;">
        <el-option v-for="(item,index) in Tool.map2arr($enums.auditStatus)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
      </el-select>
      <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList()" type="default">重置</el-button>
      <!--      <el-button @click="exportExcel()" type="primary" style="margin-left: 10px;">-->
      <!--        导出名单-->
      <!--      </el-button>-->
      <KtButton @click="exportExcel()" label='导出名单' perms='workflow-fee-export' type="primary"/>
    </div>
    <div class="">
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="pass()" type="primary" style="margin-right: 10px;">审核通过</el-button>
        <el-button @click="unPass()" type="danger" style="margin-right: 10px;">审核不通过</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column type="selection" width="55" :selectable="row=>row.auditStatus==1"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业"></el-table-column>
        <el-table-column prop="agentName" label="所属考级点"></el-table-column>
        <el-table-column prop="enrollStartTime" label="上浮比例">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.childrenList" :key="index">
              {{item.gradeName}}:{{item.adjustFee}}(上浮:{{item.feeRate}}%)
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="申请时间"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            {{$enums.auditStatus[scope.row.auditStatus]}}
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import KtButton from '../../components/ktButton'

export default {
  name: 'list',
  components: { KtButton },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, agentId: this.$route.query.agentId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      batchList: [],
      specialtyList: [],
      agentList: [],
      multipleSelection: [],
      taskInterval: 0
    }
  },
  async created () {
    await this.getPermission()
    this.batchList = await this.$HTTP.ApiBatch.getList({ isFeeAudit: 1, batchStatus: [2, 3], showAllBatch: 1 })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('请先添加考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiFeeAudit.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async pass () {
      if (!this.multipleSelection.length) {
        throw new Error('请选择要操作的记录')
      }
      let confirm = await this.$confirm('确定要通过该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        await this.$HTTP.ApiFeeAudit.pass({
          batchId: this.queryParam.batchId,
          auditIds: this.Tool.joinList(this.multipleSelection, 'feeAuditlogId')
        })
        await this.getPage()
      }
    },
    async unPass () {
      if (!this.multipleSelection.length) {
        throw new Error('请选择要操作的记录')
      }
      let prompt = await this.$prompt('', '不通过原因',
        {
          inputType: 'textarea',
          inputPattern: /^[.\s\S]{1,100}$/,
          inputErrorMessage: '100字内',
          inputValue: null,
          inputPlaceholder: '请填写审核不通过原因（100字内）',
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
      if (prompt.value) {
        await this.$HTTP.ApiFeeAudit.unPass({
          batchId: this.queryParam.batchId,
          reason: prompt.value,
          auditIds: this.Tool.joinList(this.multipleSelection, 'feeAuditlogId')
        })
        await this.getPage()
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiFeeAudit.exportExcel(this.queryParam.batchId)
        this.getTaskInfo('export_fee_audit')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          if (taskInfo) {
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
